import { get, post } from './apiUtils';

const defaultUrl = '/Ingredients/';

export default {
  getIngredientList: () => get(defaultUrl),
  getIngredient: ingredientId => get(`${defaultUrl}${ingredientId}`),
  saveIngredient: data => post(`${defaultUrl}`, data),
};
